var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBags(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-bags",
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33366 9.16675H11.667V10.8334H8.33366V9.16675Z",
    fill: "#7E8A96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.167 4.16675V3.33341C14.167 2.41295 13.4208 1.66675 12.5003 1.66675H7.50033C6.57981 1.66675 5.83366 2.41295 5.83366 3.33341V4.16675H3.33366C1.95294 4.16675 0.833658 5.28603 0.833658 6.66675V15.0001C0.833658 16.3808 1.95294 17.5001 3.33366 17.5001H16.667C18.0477 17.5001 19.167 16.3808 19.167 15.0001V6.66675C19.167 5.28603 18.0477 4.16675 16.667 4.16675H14.167ZM12.5003 3.33341H7.50033V4.16675H12.5003V3.33341ZM16.667 5.83341C17.1272 5.83341 17.5003 6.20649 17.5003 6.66675V11.6667H2.50032V6.66675C2.50032 6.20649 2.87345 5.83341 3.33366 5.83341H16.667ZM17.5003 15.0001V13.3334H2.50032V15.0001C2.50032 15.4603 2.87345 15.8334 3.33366 15.8334H16.667C17.1272 15.8334 17.5003 15.4603 17.5003 15.0001Z",
    fill: "#7E8A96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBags);
export default __webpack_public_path__ + "static/media/bags.570efac8.svg";
export { ForwardRef as ReactComponent };